import React, { useCallback } from 'react';
import { gql } from '@yi/core';

import { useRestorePosition, useSavePosition } from '~/src/components/MediaPlayer';

import { getRestoredMediaPosition } from './getRestoredMediaPosition';
import { usePlayback } from './PlaybackProvider';

export const SaveAndRestorePosition: React.FC = () => {
  const { episode } = usePlayback();

  const getTimeToSet = useCallback(
    (lastSavedTime: number) => {
      const mediaDurationInSec = episode.mediaDuration()?.seconds ?? null;
      return getRestoredMediaPosition(lastSavedTime, mediaDurationInSec);
    },
    [episode],
  );

  useSavePosition({
    contentId: episode.id(),
    contentType: gql.typesClient.MediaPositionContentType.SERIES,
    shouldSaveNearTheEnd: true,
  });
  useRestorePosition({
    contentId: episode.id(),
    contentType: gql.typesClient.MediaPositionContentType.SERIES,
    getTimeToSet,
  });
  return null;
};
